'use client';

import { ChatView } from '@/components/chat/ChatView';
import { useChatController } from '@/components/chat/use-chat-controller';

type ChatProps = {
    onMessageSubmitted?: () => void;
};

const Chat = ({ onMessageSubmitted }: ChatProps) => {
    const controller = useChatController({ onMessageSubmitted });

    return <ChatView {...controller} />;
};

export default Chat;
